import React from 'react';

/**
 * Lucide-style panel-left-open / panel-left-close.
 * Divider is inset so stroke caps don't poke past the frame.
 */
const SidebarPanelIcon = ({ className, direction = 'expand' }) => {
  const isExpand = direction === 'expand';

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="18" height="18" x="3" y="3" rx="2" />
      {/* Inset from frame edges so the rail doesn't overshoot the stroke */}
      <path d="M9 5.5v13" />
      <path d={isExpand ? 'm14 9 3 3-3 3' : 'm16 15-3-3 3-3'} />
    </svg>
  );
};

export default SidebarPanelIcon;
